import React, {useMemo} from 'react'
import {canvasElementsRegistry} from '../elements/CanvasElementsRegistry'
import {TransformerLayerProps} from '../transformerLayers/TransformerLayer'
import {TransformerUIProps} from './TransformerUI'

export function TransformerUIManager(props: TransformerUIProps) {
  const TransformerUIComponent = useMemo(
    () => canvasElementsRegistry[props.element.shapeType]?.transformerUI,
    [props.element.shapeType]
  )

  return (
    <TransformerUIComponent
      element={props.element}
      onChange={props.onChange}
      transformerProps={props.transformerProps}
      onTransformerPropsChange={props.onTransformerPropsChange}
    />
  )
}
